export default __webpack_public_path__ + "static/media/XHMJINPB0JW.c04be719.png";